export const CURRENCY_DEFAULT_SIZE = 24;
